import {
  AccordionDetails,
  Alert,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Confirm } from 'src/components/common/Confirm';
import { FileUpload } from 'src/components/common/FileUpload';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { sendRequest } from 'src/hooks/useFetch';
import { store, useAppDispatch, useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useIMVCheckListPage } from './UseIMVChecklistPage';

const SeriousAdverseEvents: React.FunctionComponent<any> = ({
  handleCheck,
  isDisable,
  validationObj,
  fileObjects4,
  setFileObjects4,
  setSection5,
  setIsChanged,
  setIsDataUpdate,
  disable
}) => {
  const [newAr, setNewAr] = useState<any>([]);
  const [isSubmitEnable, setIsSubmitEnable] = useState(false);
  const [openUploadDocument, setOpenUploadDocument] = React.useState(false);
  const dispatchApp = useAppDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { uploadDocument, uploadDocumentData } = useIMVCheckListPage();
  const { checkPermission } = usePermissionWrapper();
  const [openDelete, setOpenDelete] = useState(false);
  const deleteID = null;
  const dispatch = useDispatch();

  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `; // const maxFileSize=5000000;

    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    }
    return message;
  };
  const handleClose = () => {
    // do nothing
  };

  const handleCloseUploadDocument = () => {
    setOpenUploadDocument(false);
  };

  useEffect(() => {
    if (validationObj.stdy_imvcl_sreport_review_comm) {
      const files: any[] = [];
      const ids = validationObj?.stdy_imvcl_sreport_review_comm?.split(',');
      ids.map((id: any) => {
        const trim = id.trim();
        files.push(trim);
      });
      uploadDocument({ data: files });
    }
  }, [validationObj]);

  useEffect(() => {
    if (uploadDocumentData) {
      setFileObjects4(uploadDocumentData);
    }
  }, [uploadDocumentData]);

  const uploadOtherDocuments = async (files: any): Promise<any> => {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      const options = {
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME
        }
      };
      const response: any = await sendRequest('sqreport_filemaster_Other_Upload_Documents', options);

      return response;
    } catch {
      dispatchApp(setMessage({ msgDetails: 'Error while file uploading.', severity: 'error' }));

      return Promise.reject();
    }
  };

  const uploadDataFile = async (): Promise<any> => {
    if (newAr.length > 0) {
      const fileExist = newAr.filter((o1: any) => fileObjects4.some((o2: any) => o1.path === o2.ctms_raw_file_name));
      if (fileExist.length > 0) {
        store.dispatch(
          dispatchApp(
            setMessage({
              msgDetails: 'The selected document(s) is already present in the successfully uploaded list',
              severity: 'error'
            })
          )
        );
      } else {
        setIsSubmitEnable(true);
        const result = await uploadOtherDocuments(newAr);
        setIsSubmitEnable(false);
        const data: string[] = validationObj.stdy_imvcl_sreport_review_comm
          ? [validationObj.stdy_imvcl_sreport_review_comm]
          : [];
        result?.map((item: { id: string }) => {
          data.push(item.id);
        });

        setSection5({ ...validationObj, stdy_imvcl_sreport_review_comm: data.join(', ') });
        setConfirmExitValue(dispatch, true);
        setIsChanged(true);

        if (Array.isArray(result)) {
          setFileObjects4([...fileObjects4, ...result]);
        }
      }
    }
    setOpenUploadDocument(false);
  };

  const handleUploadDocument = () => {
    // setFileObjects4(newAr);
    const nameArr = newAr.map((ele: any) => {
      return ele.name;
    });
    const duplicate = nameArr.some((item: any, idx: number) => {
      return nameArr.indexOf(item) !== idx;
    });
    if (duplicate) {
      dispatchApp(setMessage({ msgDetails: 'Please Remove Duplicate file', severity: 'error' }));
    } else {
      uploadDataFile();
      setIsSubmitEnable(false);
      setIsDataUpdate(true);
    }
  };

  const deleteFile = () => {
    setOpenDelete(false);
    const files = fileObjects4.filter((item: any) => item.id !== deleteID);
    setFileObjects4(files);
    const data: string[] = [];
    files?.map((item: { id: string }) => {
      data.push(item.id);
    });
  };

  const handleRemoveItem = async (fileId: any) => {
    const isConfirmed = window.confirm('Do you want to delete the uploaded document?');
    if (isConfirmed) {
      const files = fileObjects4.filter((item: any) => item.id !== fileId);
      setFileObjects4(files);
      const data: string[] = [];
      files?.map((item: { id: string }) => {
        data.push(item.id);
      });
      // setSection4({ ...section4, stdy_imvcl_sa_ss_st_attachment1: data.join(', ') });
    }
  };
  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Have any new serious adverse events (SAEs) or follow up reports been identified since the last visit?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sae_fup}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sae_fup"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_fup == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_fup == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sae_fup_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sae_fup_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Were all SAEs reported in accordance with the protocol specific and local requirements?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sae_report}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sae_report"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_report == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_report == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sae_report_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sae_report_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Were all SAEs reported to Sponsor within 24 hours of site awareness?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sae_sponsor}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sae_sponsor"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_sponsor == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_sponsor == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sae_sponsor_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sae_sponsor_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Have SAEs been reported to the IRB/EC and local RA (if applicable) as per local guidelines?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sae_irb}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sae_irb"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_irb == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sae_irb == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sae_irb_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sae_irb_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Are all ongoing events being followed up as per protocol?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_event_fup}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_event_fup"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_event_fup == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_event_fup == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_event_fup_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_event_fup_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Have all Sponsor issued safety reports been received by site and submitted to IRB/EC as per local
                guidelines?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sreport_irb}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sreport_irb"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sreport_irb == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sreport_irb == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sreport_irb_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sreport_irb_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7} pr={1}>
                Is there documentation to show that the PI has reviewed the safety reports as required by local
                regulations?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvcl_sreport_review}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvcl_sreport_review"
                    onChange={e => handleCheck(e, 'section5')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sreport_review == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvcl_sreport_review == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvcl_sreport_review_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvcl_sreport_review_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section5')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-start">
          <Stack spacing={2} direction="row">
            <Button variant="contained" sx={{ ml: 2, mb: 2 }} disabled>
              Attachments
            </Button>

            <div>
              <PopupComponent
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openUploadDocument}
                maxWidth="md"
                className="uploadModal"
              >
                <DialogContent>
                  <FileUpload
                    showPreviewsInDropzone={false}
                    className={'uploadFile withFakeBtn multiple'}
                    onChange={files => {
                      if (files.length > 0) {
                        setNewAr([...files]);
                        //setUploadedFiles([...uploadedFiles, ...files]);
                        // setUploadedFiles([...files]);
                        setIsSubmitEnable(true);
                      } else {
                        setIsSubmitEnable(false);
                      }
                    }}
                    isUpload
                    defaultMsg={'Your file upload has been successfully initiated'}
                    successMsg={'Drag and drop your file here or'}
                    fileObjects={[]}
                    maxFileSize={5000000}
                    showPreviews
                    useChipsForPreview
                    previewText=""
                    getDropRejectMessage={handleRejectedMessage}
                    acceptedFiles={[
                      '.jpg',
                      '.jpeg',
                      '.gif',
                      '.png',
                      '.bmp',
                      '.tif',
                      '.tiff',
                      '.psd',
                      '.pdf',
                      '.doc',
                      '.docx',
                      '.xls',
                      '.xlsx'
                    ]}
                  />
                </DialogContent>
                <Alert severity="info" sx={{ mr: 2, ml: 2 }}>
                  Documents uploaded here are not stored in eTMF
                </Alert>
                <DialogActions>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="text"
                      href="#contained-buttons"
                      className="grey-btn"
                      onClick={handleCloseUploadDocument}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="text"
                      href="#contained-buttons"
                      onClick={handleUploadDocument}
                      disabled={!isSubmitEnable}
                    >
                      Submit
                    </Button>
                  </Stack>
                </DialogActions>
              </PopupComponent>
            </div>
          </Stack>
        </Grid>
        <Grid item md={12} pl={2} pt={0} className={fileObjects4.length > 0 ? 'rightFadedOverflowHidden' : ''}>
          <Stack direction="row" className="overflowHiddenStack">
            {fileObjects4.map((item: any) => {
              return (
                <Chip
                  disabled={!checkPermission('delete_imvchecklistdocument') || !checkPermission('update_imvchecklist')}
                  key={item.id}
                  label={item.ctms_raw_file_name}
                  variant="outlined"
                  onDelete={() => handleRemoveItem(item.id)}
                  color="primary"
                  sx={{ fontSize: '13px', fontWeight: '700', mr: 1, mb: 1, maxWidth: '32%' }}
                  size="small"
                />
              );
            })}
          </Stack>
        </Grid>
        <Confirm
          isOpen={openDelete}
          message="Are you sure you want to delete the uploaded document?"
          onCancel={() => setOpenDelete(false)}
          onConfirm={() => {
            deleteFile();
          }}
          btnClassName="grey-btn"
        />
      </Grid>
    </>
  );
};

export default SeriousAdverseEvents;
